/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {createContext} from 'react'

interface OutcomeProficiency {
  ratings: {
    color: string
    description: string
    mastery: boolean
    points: number
  }[]
}

export interface LMGBContextType {
  env: {
    contextURL?: string
    outcomeProficiency?: OutcomeProficiency
    accountLevelMasteryScalesFF?: boolean
    outcomesFriendlyDescriptionFF?: boolean
    allowDifferentiationTags?: boolean
    lmgbStudentReportingFF?: boolean
  }
}

const LMGBContext = createContext<LMGBContextType>({env: {}})

export const getLMGBContext = (): LMGBContextType => {
  const gradebookOptions = ENV?.GRADEBOOK_OPTIONS
  const contextURL = gradebookOptions?.context_url
  const outcomeProficiency = gradebookOptions?.outcome_proficiency
  const accountLevelMasteryScalesFF = gradebookOptions?.ACCOUNT_LEVEL_MASTERY_SCALES
  const outcomesFriendlyDescriptionFF = gradebookOptions?.OUTCOMES_FRIENDLY_DESCRIPTION
  const allowDifferentiationTags =
    gradebookOptions?.permissions?.allow_assign_to_differentiation_tags
  const lmgbStudentReportingFF = gradebookOptions?.LMGB_STUDENT_REPORTING

  return {
    env: {
      contextURL,
      outcomeProficiency,
      accountLevelMasteryScalesFF,
      outcomesFriendlyDescriptionFF,
      allowDifferentiationTags,
      lmgbStudentReportingFF,
    },
  }
}

export default LMGBContext
